<template>
  <select class="browser-default">
    <slot></slot>
  </select>
</template>

<script>
  export default {
    props: ['value'],
    watch: {
      value: function (value) {
        let select = $(this.$el);

        select.val(value);
        if(value && value != ''){
          select.closest('.input-field').find('label').addClass('active');
        }

        select.select2("destroy");
        select.select2();
      }
    },
    methods:{},
    mounted: function () {
      let vm = this;
      let select = $(this.$el);

      select.select2();

      select.on("change", function (e) {
        vm.$emit('input', $(this).val());
        $(this).closest('.input-field').find('label').addClass('active');
      });
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/AutoCompleteSelect.vue